import React from 'react';
import { withRouter } from 'react-router-dom';
import withAuthorization from '../../hoc/withAuthorization';
import LargePaper from '../../components/Layout/LargePaper';
import stylesDefault from '../../constants/stylesDefault';
import PasswordChangeForm from '../../components/PasswordChangeForm/PasswordChangeForm';

export const PasswordChangePage = props =>
    <LargePaper>
        <h1 style={stylesDefault.title}>Changement de mot de passe</h1>
        <PasswordChangeForm history={props.history}/>
    </LargePaper>;

const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(withRouter(PasswordChangePage));



// WEBPACK FOOTER //
// ./src/containers/PasswordChangePage/PasswordChangePage.jsx